import { c as _c } from "react/compiler-runtime";
import { Icon, IconType } from "@justhome/react-ui";
import clsx from "clsx";
const colors = {
  warning: {
    bg: "bg-warning/60",
    text: "text-marigold-750"
  },
  success: {
    bg: "bg-primary-50",
    text: "text-primary-800"
  }
};
interface StatusIconProps {
  color: keyof typeof colors;
  icon: IconType;
}
const StatusIcon = t0 => {
  const $ = _c(10);
  const {
    color,
    icon
  } = t0;
  const colorConfig = colors[color];
  let t1;
  if ($[0] !== colorConfig.bg) {
    t1 = clsx("rounded-full p-2s flex", colorConfig.bg);
    $[0] = colorConfig.bg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== colorConfig.text) {
    t2 = clsx(colorConfig.text);
    $[2] = colorConfig.text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== icon || $[5] !== t2) {
    t3 = <Icon type={icon} className={t2} size="32" />;
    $[4] = icon;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default StatusIcon;